
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/android/local/browser-history",
      function () {
        return require("private-next-pages/android/local/browser-history/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/android/local/browser-history"])
      });
    }
  